// extracted by mini-css-extract-plugin
module.exports = {"root":"promoted-item_root__g3lF3","text":"promoted-item_text__TtS1A"};